import { getI18n } from 'react-i18next';

import Config from '../../../../Config';
import Logger from '../../../../lib/Logger';
import Events from '../../../../lib/EventEmitter';

import SmsConversationScreen from './containers/SmsConversationScreenContainer';

const register = () => {
  Logger.log('debug', `smsConversations.register()`);

  if (Config.getIn(['MODULE_TOGGLES', 'smsConversations', 'routes'])) {
    Events.dispatch(
      'ADD_MAIN_ROUTES',

      // screen name (key): [route type (element), path (prop), exact (prop), component (prop), route name]
      {
        SmsConversationScreen: [
          'PrivateRoute',
          '/sms-conversations',
          true,
          SmsConversationScreen,
          getI18n().t('sms_conversations_route_main'),
        ],
      }
    );
  }
};

export default register;

Logger.log('silly', `smsConversations.register() loaded.`);
